import React, { Component } from "react";
import "./HomeTourModal.css";
import {injectIntl} from "react-intl";
import GirlTour from "../../../assets/images/girl_tour.png";
import ExploreStep4Img from "../../../assets/images/explore-step4-img-2.png";

export class ExploreStep4 extends Component {

    render(){

        return (
            <React.Fragment>
                <div className="e-t-container step2 step4">
                    <div className="e-t-imgcont step2">
                        <img src={GirlTour} alt="girl" className="e-t-img-girl-step2"/>
                    </div>
                    <div className="e-t-texts step4">
                        <img src={ExploreStep4Img} alt="girl" className="e-t-img-step4"/>
                        <p className="e-t-subtitle step4">
                            En esta opción podrás subir tus <span className="e-t-span-color">Assets</span><br/>arrastrándola y cargandola de manera fácil.
                        </p>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default injectIntl(ExploreStep4);
